import throttle from 'lodash/throttle';

const throttleFetch = (milliseconds: number) => {
	return throttle((searchValue: string, func: (searchValue: string) => void) => {
		func(searchValue);
	}, milliseconds);
}

export default throttleFetch;